<template>
  <div>
    <h3 class="title is-3">
      <router-link to="/">
        <b-icon icon="chevron-left" size="is-small"></b-icon>
      </router-link>&nbsp;
      Video Reimport
    </h3>
    <div class="box">
      <h4 class="title is-4">Reimport Details</h4>
      <form @submit.prevent="reimport">
        <div class="field">
          <input
            class="input"
            type="text"
            placeholder="Please enter the SS ID of the video to import"
            required
            v-model="id"
          >
        </div>
        <div class="field">
          <input type="submit" value="Reimport" class="button is-primary">
        </div>
      </form>
    </div>
    <loading v-if="loading"></loading>
    <div class="box" v-if="data && !loading">
      <h4 class="title is-4">Video Data</h4>
      <tree-view :data="data" :options="{rootObjectKey: ''}"></tree-view>
    </div>
  </div>
</template>

<script>
import { REIMPORT_VIDEO } from "@/store/actions";
import Loading from "@/components/Loading";

function getParameterByName(name) {
  const url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export default {
  name: "video-reimport",
  components: {
    Loading
  },
  data() {
    return {
      id: null,
      loading: false,
      data: null
    };
  },
  mounted() {
    const id_parameter = getParameterByName("id");
    if (id_parameter && id_parameter.length > 0) {
      this.id = id_parameter;
      this.reimport();
    }
  },
  methods: {
    reimport() {
      this.loading = true;
      this.$store
        .dispatch(REIMPORT_VIDEO, this.id)
        .then(res => {
          console.log(res);
		  this.data = res.data;
		  this.$success('Reimport succeeded')
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>